import React, { useState } from "react";
import { Tabs } from "antd";
import { useLocation } from "react-router-dom";
import ClientForm from "./ClientForm";
import EditClientSettings from "../settings/edit";
import ClientTeams from "../teams/index";
import ClientUsers from "../users/index";
import SectionHeader from "components/section/SectionHeader";
import PopupButton from "components/button/PopupButton";
import { useNavigate } from 'react-router-dom';
import CustomTabs from "components/tabs/customTab";

const ClientTab = ({ recordId }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const pathParts = location.pathname.split("/").filter(Boolean);
  const lastSegment = pathParts[pathParts.length - 1];
  const [activeTab, setActiveTab] = useState(lastSegment);

  const tabOptions = [
    { value: "view", label: "Details" },
    { value: "client-teams", label: "Teams" },
    { value: "client-users", label: "Users/Supervisors" },
    { value: "settings", label: "Settings" },
  ];

  const renderContent = () => {
    switch (activeTab) {
      case "view":
        return (
          <div className="content-wrapper p-5 mb-2 rounded-xl border shadow-md">
            <SectionHeader title="Client Details">
              <PopupButton id="edit_client" title="Edit Client" label="Edit">
                <ClientForm recordId={recordId} mode="edit" />
              </PopupButton>
            </SectionHeader>
            <ClientForm recordId={recordId} mode="view" />
          </div>
        );

      case "client-teams":
        return <ClientTeams clientId={recordId} />;

      case "client-users":
        return <ClientUsers clientId={recordId} />;

      case "settings":
        return <EditClientSettings clientId={recordId} />;

      default:
        return null;
    }
  };

  const onChange = (key) => {
    setActiveTab(key);
    navigate(`/console/clients/${recordId}/${key}`);
  };

  return (
    <div className="space-y-4">
      <CustomTabs
        tabs={tabOptions}
        activeTab={activeTab}
        onChange={onChange}
        height="h-10"
      />

      <div>{renderContent()}</div>
    </div>
  );
};

export default ClientTab;
